import { render } from "./AlignRight.vue?vue&type=template&id=f65224a4&scoped=true"
const script = {}

import "./AlignRight.vue?vue&type=style&index=0&id=f65224a4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65224a4"]])

export default __exports__